import React, { useEffect, useState } from "react";
import AccountSettingSidebar from "../../../component/common/layout/AccountSettingSidebar";
import LeftSidebarNew from "../../../component/common/layout/LeftSidebarNew";
import SurveyListHeader from "../../../component/common/layout/SurveyListHeader";
import Svg from "../../../component/common/Svg";
import Card from "../../../core/Card";
import style from "../../style.module.css";
import Input from "../../../core/Inputs/DefaultInput";
import UserRolesEmpty from "./empty-state/UserRole";
import SearchInput from "../../../core/Inputs/SearchInput";
import SurveyListSidebar from "../../../component/common/layout/SurveyListSidebar";
import { Link } from "react-router-dom";
import { useTranslation } from 'react-i18next';
import {
  addRole,
  deleteRole,
  editRole,
  getModules,
  getRoleList,
} from "../../../store/actions/roleAction";
import { useDispatch, useSelector } from "react-redux";
import moment from "moment";
import { Formik } from "formik";
import { createRoleSchema } from "../../../schema/Role";
import CreatableSelect from "react-select/creatable";
import { toast } from "react-toastify";
import NestedMenuToggle from "./NestedMenuToggle";

export default function UserRoles() {
  const dispatch = useDispatch();
  const { t, i18n } = useTranslation();
  const {
    roleDataLoading: loading,
    roleData: roleList,
    isAddingRole,
    moduleData: moduleData,
    deleteMessage,
    isDeletingRole,
  } = useSelector((state) => state.roleData);

  const [selectedDeleteRole, setSelectedDeleteRole] = useState(null);
  const [roleListForSelect, setRoleListForSelect] = useState([]);
  const [filteredRoleListForSelect, setFilteredRoleListForSelect] = useState(
    []
  );
  const [permissionModalData, setPermissionModalData] = useState(null);
  const [isEdit, setIsEdit] = React.useState(false);
  const [permision, setPermisioin] = React.useState([]);
  const [id, setId] = React.useState("");
  const [modalName, setModalName] = React.useState("");
  const [parentId, setParentId] = React.useState(null);
  const [serverParams, setServerParams] = useState({
    startingLimit: 0,
    resultsPerPage: 8,
    search: "",
  });

  const getRoles = () => {
    dispatch(getRoleList(serverParams));
  };

  const getAllModules = async () => {
    dispatch(getModules());
  };

  const editApi = async (payload) => {
    dispatch(editRole(payload));
  };
  const addApi = async (payload) => {
    dispatch(addRole(payload));
  };
  const deleteapi = async () => {
    // e.preventDefault();
    console.log("selectedDeleteRole", selectedDeleteRole);
    const payload = {
      role_id: selectedDeleteRole.id,
    };
    dispatch(deleteRole(payload));
  };

  const openRoleAddEditModal = async (row = null, action = null) => {
    if (row && action) {
      let updatedData = roleListForSelect.filter(
        (item) => item.value !== row.id
      );
      setFilteredRoleListForSelect(updatedData);
      setIsEdit(true);
      setId(row.id);
      setPermissionModalData(null);
      setTimeout(() => {
        const saved = JSON.parse(row?.module_permissions) || {};
        const template = JSON.parse(JSON.stringify(moduleData)) || {};
        const merged = { ...template };
        Object.keys(saved).forEach((key) => {
          if (template[key]) {
            merged[key] = { ...template[key], ...saved[key], name: template[key].name };
          } else {
            merged[key] = saved[key];
          }
        });
        Object.keys(template).forEach((key) => {
          if (!saved[key]) {
            const zeroed = { ...template[key] };
            Object.keys(zeroed).forEach((k) => {
              if (k !== 'name') zeroed[k] = 0;
            });
            merged[key] = zeroed;
          }
        });
        setPermissionModalData(merged);
      }, 0);
      setModalName(row.role_name);
      setParentId(row.parent_id);
    } else {
      setFilteredRoleListForSelect(roleListForSelect);
      setIsEdit(false);
      setId("");
      setPermissionModalData(null);
      setTimeout(() => {
        setPermissionModalData(JSON.parse(JSON.stringify(moduleData)));
      }, 0);
      setModalName("");
      setParentId("");
    }
    let addRole = document.getElementById("addRoleModal");
    let roleModal = window.bootstrap.Modal.getOrCreateInstance(addRole);
    if (roleModal && !roleModal._isShown) {
      roleModal.show();
    }
  };

  const closeRoleAddEditModal = () => {
    setIsEdit(false);
    setId("");
    setModalName("");
    setParentId("");
    let addRole = document.getElementById("addRoleModal");
    let roleModal = window.bootstrap.Modal.getOrCreateInstance(addRole);
    if (roleModal && roleModal._isShown) {
      roleModal.hide();
      getRoles();
    }
  };
  useEffect(() => {
    if (!isAddingRole) {
      closeRoleAddEditModal();
    }
    if (isAddingRole) {
      openRoleAddEditModal();
    }
  }, [isAddingRole]);

  useEffect(() => {
    if (!isDeletingRole) {
      let deleteRoleModal = document.getElementById("deleteModal");
      let delRoleModal =
        window.bootstrap.Modal.getOrCreateInstance(deleteRoleModal);
      if (delRoleModal && delRoleModal._isShown) {
        delRoleModal.hide();
        getRoles();
      }

    }
  }, [isDeletingRole]);

  useEffect(() => {
    getAllModules();
  }, []);

  useEffect(() => {
    getRoles();
  }, [serverParams]);

  useEffect(() => {
    let roleOptions = [];
    roleList.map((ele) => {
      roleOptions.push({
        value: ele.id,
        label: ele.role_name,
      });
    });
    setRoleListForSelect(roleOptions);
  }, [roleList]);

  useEffect(() => {
    setPermissionModalData(moduleData);
  }, [moduleData]);

  useEffect(() => {
    setPermisioin(permissionModalData);
  }, [permissionModalData]);

  useEffect(() => {
    if (deleteMessage) {
      toast.error(deleteMessage);
    }
  }, [deleteMessage]);

  return (
    <>
      <div className="d-flex flex-column main-outer-wrapper main-site-wrapper bg-white">
        <SurveyListHeader />
        <div id="viewport" className="d-flex bg-white">
          <SurveyListSidebar />
          <div className="flex-grow-1 d-flex">
            <AccountSettingSidebar />
            <div className="flex-grow-1 page-content-wrap d-flex flex-column">
              <div className="page-heading d-md-flex align-items-center">
                <div className="flex-grow-1">
                  {/* breadcrumbs here */}
                  <nav aria-label="breadcrumb">
                    <ol className="breadcrumb">
                      <li className="breadcrumb-item">
                        <Link to="/admin/settings/profile">{t('settings.title')}</Link>
                      </li>
                      <li className="breadcrumb-item">
                        <Link to="/admin/settings/user-roles">{t('settings.users_and_teams.breadcrumb_heading')}</Link>
                      </li>
                      <li className="breadcrumb-item active" aria-current="page">
                        <strong>{t('settings.roles.heading')}</strong>
                      </li>
                    </ol>
                  </nav>
                  {/* breadcrumbs ends here */}
                  <div className="d-flex align-items-center">
                    <NestedMenuToggle />
                    <div className="flex-grow-1 ps-3 ps-lg-0">
                      <h1>{t('settings.roles.heading')}
                      </h1>
                      <p className='pt-2 mb-0'>{t('settings.roles.description')}
                      </p>
                    </div>
                  </div>
                </div>
                {window.modulePermissions.M4.add == 1 && (
                  <div className="button-wrap mt-3 mt-md-0">
                    <button
                      type="button"
                      className="btn btn-primary add-btn"
                      onClick={() => {
                        setIsEdit(false);
                        openRoleAddEditModal();
                      }}
                      // data-bs-toggle="modal"
                      // data-bs-target="#addRoleModal"
                      srno="1"
                      value="1"
                    >
                      <Svg name="plus" /> {t('settings.roles.create_role.heading')}{" "}
                    </button>
                  </div>
                )}
              </div>
              <div className="role-wrapper flex-grow-1">
                {/* Empty State of User Role */}
                {/* <UserRolesEmpty /> */}
                <div className="table-wrapper-view">
                  <div className="search-filter d-flex align-items--center">
                    <div className="flex-grow-1 search-filter-padding">
                      <SearchInput
                        className="custom-search-input"
                        type="def"
                        value={serverParams.search}
                        view="outlined"
                        color="primary"
                        placeholder={t('settings.users_and_teams.users.search')}
                        fill={true}
                        onChange={(e) => {
                          setServerParams({
                            ...serverParams,
                            search: e.target.value,
                          });
                        }}
                        onClear={() => {
                          setServerParams({
                            ...serverParams,
                            search: "",
                          });
                        }}
                      />
                    </div>
                    {/* <div className="drop-wrap d-flex align-items-center">
                      <label>Sort By - </label>
                      <div className="dropdown table-dropdown ques-options">
                        <button
                          className="btn dropdown-tgl"
                          type="button"
                          id="languages"
                          data-bs-toggle="dropdown"
                          aria-haspopup="true"
                          aria-expanded="false"
                        >
                          Recently added
                        </button>
                        <div
                          className="dropdown-menu"
                          aria-labelledby="languages"
                        >
                          <a className="dropdown-item" href="#">
                            {" "}
                            Value 1{" "}
                          </a>
                          <a className="dropdown-item" href="#">
                            {" "}
                            Value 2{" "}
                          </a>
                          <a className="dropdown-item" href="#">
                            {" "}
                            Value 3{" "}
                          </a>
                        </div>
                      </div>
                    </div> */}
                  </div>
                  <div className="table-responsive">
                    <table className="table mb-4">
                      <thead>
                        <tr>
                          {/* <th scope="col">
                            <input
                              className="form-check-input"
                              type="checkbox"
                            />
                          </th> */}
                          <th scope="col">{t('settings.roles.role_list.sr_no')}
                          </th>
                          <th scope="col">{t('settings.roles.role_list.name')}
                          </th>
                          <th scope="col">{t('settings.roles.role_list.date_added')}
                          </th>
                          <th scope="col">{t('settings.roles.role_list.action')}
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        {roleList.length > 0 &&
                          roleList.map((role, roleIndex) => (
                            <tr key={roleIndex}>
                              {/* <td>
                                <input
                                  className="form-check-input"
                                  type="checkbox"
                                />
                              </td> */}
                              <td>{roleIndex + 1}</td>
                              <td>{role.role_name}</td>
                              <td>
                              {moment(role.add_date_time, "DD-MM-YYYY | hh:mm A").format("DD/MM/YYYY")}
                              </td>
                              <td>
                                <div className="d-flex">
                                  {role.role_name != 'Admin' && (

                                    <>
                                      {window.modulePermissions.M4.edit == 1 && (
                                        <a
                                          href="#"
                                          className="action-btn"
                                          onClick={() => {
                                            openRoleAddEditModal(role, "edit");
                                          }}
                                        >
                                          <Svg name="table-edit" />
                                        </a>
                                      )}
                                      {window.modulePermissions.M4.del == 1 && (
                                        <a
                                          href="#"
                                          data-bs-toggle="modal"
                                          data-bs-target="#deleteModal"
                                          className="action-btn"
                                          onClick={() => setSelectedDeleteRole(role)}
                                        >
                                          <Svg name="table-delete" />
                                        </a>
                                      )}
                                    </>
                                  )}
                                </div>
                              </td>
                            </tr>
                          ))}
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div
        className="customvar-modal modal fade setting-modal"
        id="addRoleModal"
        tabIndex={-1}
        aria-labelledby="addRoleModalLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-dialog-centered" style={{ maxWidth: '880px' }}>
          <div className="modal-content">
            <div className="modal-body">
              <div className={"formcontainer" + " " + style.container}>
                <div className={"formvawrapper modal-role-wide" + " " + style.wrapper}>
                  <Card
                    view="raised"
                    className={"formstyle p-4" + " " + style.card}
                  >
                    <div className="modal-heading">
                      <h4>{isEdit ? t('settings.roles.create_role.edit')
                        : t('settings.roles.create_role.add_new')
                      } {t('settings.roles.create_role.role')}
                      </h4>
                    </div>
                    <Formik
                      initialValues={{
                        name: modalName,
                        permissions: permissionModalData,
                        parent_id: parentId,
                      }}
                      enableReinitialize
                      validationSchema={createRoleSchema}
                      onSubmit={(values, { setSubmitting, resetForm }) => {
                        if (isEdit) {
                          const payload = {
                            role_id: id,
                            name: values.name,
                            permissions: JSON.stringify(values.permissions),
                            parent_id: values.parent_id,
                          };
                          editApi(payload);
                        } else {
                          const payload = {
                            name: values.name,
                            permissions: JSON.stringify(values.permissions),
                            parent_id: values.parent_id,
                          };
                          addApi(payload);
                        }
                        let addUserSuccessModal =
                          document.getElementById("addUserSuccess");
                        let modal =
                          window.bootstrap.Modal.getOrCreateInstance(
                            addUserSuccessModal
                          );
                        if (modal && !modal._isShown) {
                          modal.show();
                        }
                      }}
                    >
                      {({
                        values,
                        errors,
                        resetForm,
                        handleChange,
                        handleSubmit,
                        setFieldValue,
                      }) => (
                        <form onSubmit={handleSubmit}>
                          <div className="form-wrapper">
                            <div className="form-group mb-3 position-relative">
                              <label>{t('settings.roles.common.role_name')}<span className="text-primary">*</span>
                              </label>
                              <Input
                                type="text"
                                view="outlined"
                                dense={false}
                                color="default"
                                label=""
                                placeholder= {t('settings.roles.common.role_name')}
                                clearButton={true}
                                success={false}
                                error={false}
                                fill={true}
                                errorHelperText={null}
                                className={"formsinput"}
                                name="name"
                                value={values.name}
                                onChange={handleChange}
                              />
                              {errors.name && (
                                <div className="validation-msg">
                                  {errors.name}
                                </div>
                              )}
                            </div>
                            <div className="form-group mb-3 position-relative cstom-select">
                              <label>{t('settings.roles.common.select_parent_role')}
                              </label>
                              <CreatableSelect
                                //isClearable
                                options={filteredRoleListForSelect}
                                placeholder={t('settings.roles.common.select_parent_role')}
                                value={
                                  roleListForSelect
                                    ? roleListForSelect.find(
                                      (option) =>
                                        option.value === values.parent_id
                                    )
                                    : ""
                                }
                                onChange={(e) => {
                                  setFieldValue("parent_id", e.value);
                                }}
                              />
                            </div>
                            <div className="form-group mb-3">
                              <label className="permission-label">{t('settings.roles.common.permissions.heading')}</label>
                              <div className="permission-wrapper" style={{ maxHeight: '450px', overflowY: 'auto', border: '1px solid #eee', borderRadius: '8px' }}>
                                {permissionModalData &&
                                  (() => {
                                    const displayOrder = ['M1','M11','M12','M13','M14','M15','M16','M17','M18','M19','M20','M21','M22','M23','M3','M4','M5','M8','M9','M10','M6','M2','M7'];
                                    const allKeys = Object.keys(permissionModalData);
                                    const sortedKeys = displayOrder.filter(k => allKeys.includes(k));
                                    allKeys.forEach(k => { if (!sortedKeys.includes(k)) sortedKeys.push(k); });
                                    return sortedKeys;
                                  })().map(
                                    (obj, key) => {
                                      const mod = permissionModalData[obj];
                                      const checkboxStyle = { width: '16px', height: '16px', cursor: 'pointer', marginRight: '5px' };
                                      const labelStyle = { fontSize: '14px', cursor: 'pointer', whiteSpace: 'nowrap' };
                                      const hasTicketPerms = mod.hasOwnProperty("view_own") || mod.hasOwnProperty("view_all") || mod.hasOwnProperty("comment");
                                      const hasStandardPerms = mod.hasOwnProperty("view") || mod.hasOwnProperty("add") || mod.hasOwnProperty("edit") || mod.hasOwnProperty("del");

                                      const colStyle = { width: '90px', textAlign: 'center', flexShrink: 0 };

                                      if (hasTicketPerms && !hasStandardPerms) {
                                        return (
                                          <div key={key} style={{ display: 'flex', alignItems: 'center', padding: '12px 16px', borderBottom: '1px solid #f0f0f0' }}>
                                            <div style={{ flex: 1, fontSize: '14px', fontWeight: 500 }}>{mod?.name}</div>
                                            <div style={colStyle}>
                                              {mod.hasOwnProperty("view_own") && (
                                                <label htmlFor={"view_own" + key} style={labelStyle}>
                                                  <input className="form-check-input" type="checkbox" id={"view_own" + key} defaultChecked={mod.view_own === 1} style={checkboxStyle}
                                                    onChange={(e) => { permision[obj]["view_own"] = e.target.checked ? 1 : 0; setPermisioin((prev) => ({ ...prev, [obj]: { ...prev[obj], view_own: e.target.checked ? 1 : 0 } })); setFieldValue("permissions", { ...permision }); }}
                                                  /> Own
                                                </label>
                                              )}
                                            </div>
                                            <div style={colStyle}>
                                              {mod.hasOwnProperty("view_all") && (
                                                <label htmlFor={"view_all" + key} style={labelStyle}>
                                                  <input className="form-check-input" type="checkbox" id={"view_all" + key} defaultChecked={mod.view_all === 1} style={checkboxStyle}
                                                    onChange={(e) => { permision[obj]["view_all"] = e.target.checked ? 1 : 0; setPermisioin((prev) => ({ ...prev, [obj]: { ...prev[obj], view_all: e.target.checked ? 1 : 0 } })); setFieldValue("permissions", { ...permision }); }}
                                                  /> All
                                                </label>
                                              )}
                                            </div>
                                            <div style={colStyle}>
                                              {mod.hasOwnProperty("comment") && (
                                                <label htmlFor={"comment" + key} style={labelStyle}>
                                                  <input className="form-check-input" type="checkbox" id={"comment" + key} defaultChecked={mod.comment === 1} style={checkboxStyle}
                                                    onChange={(e) => { permision[obj]["comment"] = e.target.checked ? 1 : 0; setPermisioin((prev) => ({ ...prev, [obj]: { ...prev[obj], comment: e.target.checked ? 1 : 0 } })); setFieldValue("permissions", { ...permision }); }}
                                                  /> Comment
                                                </label>
                                              )}
                                            </div>
                                            <div style={colStyle}><span style={{ color: 'black', fontSize: '14px' }}>—</span></div>
                                          </div>
                                        );
                                      }

                                      return (
                                        <div key={key} style={{ display: 'flex', alignItems: 'center', padding: '12px 16px', borderBottom: '1px solid #f0f0f0' }}>
                                          <div style={{ flex: 1, fontSize: '14px', fontWeight: 500 }}>{mod?.name}</div>
                                          <div style={colStyle}>
                                            {mod.hasOwnProperty("view") ? (
                                              <label htmlFor={"view" + key} style={labelStyle}>
                                                <input className="form-check-input" type="checkbox" id={"view" + key} defaultChecked={mod.view === 1} style={checkboxStyle}
                                                  onChange={(e) => { permision[obj]["view"] = e.target.checked ? 1 : 0; setPermisioin((prev) => ({ ...prev, [obj]: { ...prev[obj], view: e.target.checked ? 1 : 0 } })); setFieldValue("permissions", { ...permision }); }}
                                                /> View
                                              </label>
                                            ) : <span style={{ color: 'black', fontSize: '14px' }}>—</span>}
                                          </div>
                                          <div style={colStyle}>
                                            {mod.hasOwnProperty("add") ? (
                                              <label htmlFor={"add" + key} style={labelStyle}>
                                                <input className="form-check-input" type="checkbox" id={"add" + key} defaultChecked={mod.add === 1} style={checkboxStyle}
                                                  onChange={(e) => { permision[obj]["add"] = e.target.checked ? 1 : 0; setPermisioin((prev) => ({ ...prev, [obj]: { ...prev[obj], add: e.target.checked ? 1 : 0 } })); setFieldValue("permissions", { ...permision }); }}
                                                /> Add
                                              </label>
                                            ) : <span style={{ color: 'black', fontSize: '14px' }}>—</span>}
                                          </div>
                                          <div style={colStyle}>
                                            {mod.hasOwnProperty("edit") ? (
                                              <label htmlFor={"edit" + key} style={labelStyle}>
                                                <input className="form-check-input" type="checkbox" id={"edit" + key} defaultChecked={mod.edit === 1} style={checkboxStyle}
                                                  onChange={(e) => { permision[obj]["edit"] = e.target.checked ? 1 : 0; setPermisioin((prev) => ({ ...prev, [obj]: { ...prev[obj], edit: e.target.checked ? 1 : 0 } })); setFieldValue("permissions", { ...permision }); }}
                                                /> Edit
                                              </label>
                                            ) : <span style={{ color: 'black', fontSize: '14px' }}>—</span>}
                                          </div>
                                          <div style={colStyle}>
                                            {mod.hasOwnProperty("del") ? (
                                              <label htmlFor={"del" + key} style={labelStyle}>
                                                <input className="form-check-input" type="checkbox" id={"del" + key} defaultChecked={mod.del === 1} style={checkboxStyle}
                                                  onChange={(e) => { permision[obj]["del"] = e.target.checked ? 1 : 0; setPermisioin((prev) => ({ ...prev, [obj]: { ...prev[obj], del: e.target.checked ? 1 : 0 } })); setFieldValue("permissions", { ...permision }); }}
                                                /> Delete
                                              </label>
                                            ) : <span style={{ color: 'black', fontSize: '14px' }}>—</span>}
                                          </div>
                                        </div>
                                      );
                                    }
                                  )}
                              </div>
                            </div>
                          </div>

                          <div className="button-wrap d-flex justify-content-end">
                            <button
                              type="button"
                              className="btn btn-bordered"
                              onClick={() => {
                                resetForm();
                              }}
                              data-bs-dismiss="modal"
                            >
                              {t('settings.roles.common.cancel')}

                            </button>
                            <button
                              type="submit"
                              className="btn btn-primary  ms-3"
                            >
                              {/* <Svg name="plus" /> */}
                              {/* {isEdit ? "Edit" : "Add"} */}
                              {t('settings.roles.common.save')}

                            </button>
                          </div>
                        </form>
                      )}
                    </Formik>
                  </Card>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div
        className="customvar-modal modal custom-modal fade deleteModal"
        id="deleteModal"
        tabIndex={-1}
        aria-labelledby="deleteModalLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content">
            <div className="modal-body">
              <div
                className={
                  "formvawrapper delete-modal-wrap modal-setting-medium"
                }
              >
                <div className={"formstyle p-0"}>
                  <div className="delete-body-wrap delete-language">
                    <div className="heading">
                      <h3>{t('settings.roles.delete_action.sub')}
                      </h3>
                      <p>
                        {t('settings.roles.delete_action.sub_heading')}

                      </p>
                    </div>


                    <div className="button-wrap d-flex justify-content-end">
                      <button
                        type="button"
                        className="btn btn-delete"
                        onClick={deleteapi}
                      >
                        {t('settings.roles.delete_action.delete')}

                      </button>
                      <button
                        type="button"
                        className="btn btn-bordered color-cancel ms-3"
                        data-bs-dismiss="modal"
                      >
                        {t('settings.roles.delete_action.cancel')}

                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
